import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import ReactPaginate from 'react-paginate';
import Layout from "../../shared/components/Layout";
import { Table } from "@/components/Table";
import { formatDate } from "@/utils/format";
import clearLocalStorage from "@/utils/clearLocalStorage";

import type { PlanLabels, LostNonWarrantyRequest } from "../types";
import type { Pagination } from "@/types";

import getLostNonWarranty from "../api/getLostNonWarranty";

const LostNonWarranty: React.FC = () => {
  const [lostNonWarrantyRequests, setLostNonWarrantyRequests] = useState<LostNonWarrantyRequest[]>([]);
  const [displayedLostNonWarrantyRequests, setDisplayedLostNonWarrantyRequests] = useState<LostNonWarrantyRequest[]>([]);
  const [pagination, setPagination] = useState<Pagination>({
    currentPage: 0,
    limitValue: 15,
    totalCount: 0,
    totalPages: 0
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getLostNonWarranty();
        setLostNonWarrantyRequests(response.data.lostNonWarrantyRequests);

        setPagination(prev => ({
          ...prev,
          totalCount: response.data.lostNonWarrantyRequests.length,
          totalPages: Math.ceil(response.data.lostNonWarrantyRequests.length / pagination.limitValue)
        }));
        setDisplayedLostNonWarrantyRequests(response.data.lostNonWarrantyRequests.slice(0, pagination.limitValue));
      } catch (error) {
        console.error("Error fetching facility lens data:", error);
      }
    };

    fetchData();
    clearLocalStorage();
  }, [])

  const planLabels: PlanLabels = {
    both: '両眼プラン',
    right: '片眼プラン(右眼)',
    left: '片眼プラン(左眼)'
  }

  const displayPlan = (plan: string): string => {
    if(plan === 'both') return "両眼"
    if(plan === 'right') return "片眼(右眼)"
    if(plan === 'left') return "片眼(左眼)"
    return '';
  }

  const displayStatus = (status: string): string => {
    if(status === 'before_confirmation') return '確定待ち'
    if(status === 'confirmed') return '確定済み'
    return '';
  }

  const adjustmentLostNonWarrantyRequests = displayedLostNonWarrantyRequests.map((lostNonWarrantyRequest: LostNonWarrantyRequest) => {
    return [
      {key: 'custCode', value: lostNonWarrantyRequest?.facilityAgreement?.customer?.custCode},
      {key: 'applicantNameKana', value: lostNonWarrantyRequest?.facilityAgreement?.applicant?.nameKana},
      {key: 'plan', value: planLabels[lostNonWarrantyRequest?.facilityAgreement?.plan ?? '']},
      {key: 'applicationDate', value: formatDate(lostNonWarrantyRequest.applicationDate)},
      {key: 'applicationLens', value: displayPlan(lostNonWarrantyRequest?.plan ?? '')},
    ]
  });

  const handlePageClick = (data: { selected: number }) => {
    const offset = data.selected * pagination.limitValue;
    setDisplayedLostNonWarrantyRequests(lostNonWarrantyRequests.slice(offset, offset + pagination.limitValue));
    setPagination(prev => ({ ...prev, currentPage: data.selected }));
  };

  const startIndex = pagination.currentPage * pagination.limitValue + 1;
  const endIndex = Math.min(startIndex + pagination.limitValue - 1, pagination.totalCount);
  
  return (
    <React.Fragment>
      <Layout>
        <main id="page-user_information" className="wrapper">
          <section className="sec-contact sec-contact--infor">
            <div className="inner">
              <div className="sec-contact__item mbpc-83">
                <h1 className="c-ttl__01 mbsp-23">紛失・保証外レンズ申込</h1>
                <Link to="/facility/facility_agreements/lost_non_warranty/new" className="c-btn__03 mbpc-20 pc">新規申込</Link>
                <Link to="/facility/facility_agreements/lost_non_warranty/new" className="c-btn__01 mbpc-20 sp">新規申込</Link>
                <form action="/">
                  <Table
                    thList={["お客様ID", "申込者(カナ)", "契約プラン", "レンズ申込日", "お申込レンズ"]}
                    tdList={adjustmentLostNonWarrantyRequests}
                  />
                </form>
                <ReactPaginate
                  pageCount={pagination.totalPages}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={handlePageClick}
                  containerClassName='wp-pagenavi'
                  pageClassName='page smaller'
                  pageLinkClassName='page smaller'
                  activeClassName='current' 
                  previousLabel='前へ'
                  nextLabel='次へ'
                  previousClassName=''
                  nextClassName=''
                  previousLinkClassName='previouspostslink'
                  nextLinkClassName='nextpostslink'
                  disabledClassName='disabled'
                  breakLabel='...'
                  breakClassName='page smaller'
                  breakLinkClassName='page smaller'
                />
              </div>
            </div>
          </section>
        </main>
      </Layout>
    </React.Fragment>
  )
}

export default LostNonWarranty;